const currencySigns = {
  USD: '$',
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'Lekë',
  AMD: '֏',
  ARS: '$',
  AUD: '$',
  AZN: '₼',
  BAM: 'KM',
  BDT: '৳',
  BHD: 'د.ب',
  BRL: 'R$',
  BYN: 'Br',
  CAD: '$',
  CHF: 'CHF',
  CLP: '$',
  CZK: 'Kč',
  DKK: 'kr',
  EUR: '€',
  GBP: '£',
  GEL: '₾',
  HKD: 'HK$',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  INR: '₹',
  ISK: 'kr',
  JOD: 'د.أ',
  JPY: '¥',
  KES: 'Ksh',
  KGS: '⃀',
  KRW: '₩',
  KZT: '₸',
  LKR: 'Rs',
  MAD: 'د.م',
  MDL: 'L',
  MKD: 'ден.',
  MUR: 'Rs',
  MXN: '$',
  MYR: 'RM',
  NGN: '₦',
  NOK: 'kr',
  NZD: '$',
  OMR: 'ر.ع',
  PEN: 'S/',
  PHP: '₱',
  PKR: 'Rs',
  PLN: 'zł',
  QAR: 'ر.ق',
  RON: 'lei',
  RSD: 'дин.',
  RUB: '₽',
  RWF: 'RF',
  SEK: 'kr',
  SGD: '$',
  THB: '฿',
  TJS: 'сом.',
  TRY: '₺',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  UYU: '$U',
  UZS: 'soʻm',
  VND: '₫',
  ZAR: 'R',
};

const PREFERRED_CURRENCIES = ['USD', 'EUR', 'GBP'];

export const CURRENCIES = [
  ...PREFERRED_CURRENCIES,
  ...Object.keys(currencySigns).filter((currency) => !PREFERRED_CURRENCIES.includes(currency)),
];

export const CURRENCY_SELECT_ITEMS = CURRENCIES.map((currency) => ({
  id: currency,
  name: currency,
}));

export const getCurrencySign = (currency) => currencySigns[currency] || '';
